import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakTokenParsed } from 'keycloak-js';
import { Observable } from 'rxjs';
import { DepartmentService } from './department.service';
import { UserRole } from 'app/models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  get loggedUser(): KeycloakTokenParsed | undefined {
    try {
      return this.keycloak.getKeycloakInstance().idTokenParsed;
    } catch {
      return undefined;
    }
  }

  get isAdmin(): boolean {
    return this.keycloak.getUserRoles().includes(UserRole.TD_ADMIN);
  }

  get isOfficer(): boolean {
    return this.keycloak.getUserRoles().includes(UserRole.OFFICER);
  }

  get currentRole(): Array<string> {
    return this.keycloak.getUserRoles();
  }

  get isSupervisor(): boolean {
    return this.keycloak
      .getUserRoles()
      .some((role) => role === UserRole.SUPERVISOR || role === UserRole.SUPERVISOR_LEAD);
  }

  get isOperationsRoles(): boolean {
    return this.keycloak
      .getUserRoles()
      .some(
        (role) =>
          role === UserRole.SUPERVISOR ||
          role === UserRole.SUPERVISOR_LEAD ||
          role === UserRole.TD_ADMIN ||
          role === UserRole.DEPARTMENT_ADMIN ||
          role === UserRole.CIVILIAN,
      );
  }

  constructor(
    private readonly keycloak: KeycloakService,
    private readonly departmentService: DepartmentService,
  ) {}

  getDepartmentId() {
    return this.loggedUser?.['department_id'] ?? '';
  }

  getDepartment(): Observable<{ id: string; name: string }> {
    return this.departmentService.getDepartment(this.getDepartmentId());
  }

  logout(): void {
    localStorage.removeItem('map_data');
    this.keycloak.logout(window.location.origin);
  }
}
